export default function AboutSection() {
  const pillars = [
    {
      icon: 'ri-shield-check-line',
      title: 'Security First',
      desc: 'Every application we build is designed with security at its core, ensuring your data and privacy are always protected.',
    },
    {
      icon: 'ri-speed-up-line',
      title: 'Peak Performance',
      desc: 'Optimized code and smart algorithms keep your device running at its absolute best, day in and day out.',
    },
    {
      icon: 'ri-palette-line',
      title: 'Elegant Design',
      desc: 'We believe great apps are not only powerful but beautiful — our interfaces are crafted for intuitive, delightful use.',
    },
  ];

  return (
    <section id="about" className="bg-[#FAFAF8] py-36">
      <div className="max-w-[1400px] mx-auto px-16">
        {/* Label */}
        <div className="flex items-center gap-2 mb-6">
          <div className="w-2 h-2 rounded-full bg-[#D4FF00]" />
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#8A8A8A]">Who We Are</span>
        </div>

        {/* Split layout */}
        <div className="flex items-start gap-20 mb-20">
          <div className="flex-1">
            <h2 className="text-5xl font-bold text-[#1A1A1A] leading-[1.12]">
              A dedicated team<br />
              building the future<br />
              of <span className="italic">iOS security</span>
            </h2>
          </div>
          <div className="flex-1 pt-3">
            <p className="text-[#5A5A5A] text-lg leading-relaxed mb-6">
              MOMAS D.O.O. was founded with a clear mission — to create iOS
              applications that combine cutting-edge technology with an intuitive
              user experience. Our expert team brings together deep knowledge of
              mobile security, performance optimization, and user-centered design.
            </p>
            <p className="text-[#5A5A5A] text-lg leading-relaxed">
              Based in North Macedonia, we serve users worldwide through our
              flagship iOS products. We are committed to continuous improvement,
              transparent practices, and putting the user first in every decision
              we make.
            </p>
          </div>
        </div>

        {/* Pillars */}
        <div className="grid grid-cols-3 gap-8">
          {pillars.map((p) => (
            <div
              key={p.title}
              className="bg-white rounded-2xl p-8 border border-[#F0F0F0] hover:border-[#D4FF00] transition-colors duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#D4FF00]/15 mb-6">
                <i className={`${p.icon} text-2xl text-[#1A1A1A]`} />
              </div>
              <h3 className="text-xl font-semibold text-[#1A1A1A] mb-3">{p.title}</h3>
              <p className="text-[#7A7A7A] text-sm leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>

        {/* Image band */}
        <div className="mt-16 rounded-2xl overflow-hidden" style={{ height: 380 }}>
          <img
            src="https://public.readdy.ai/ai/img_res/7532d99ec8dbf828f5a5e351f921e806.jpg"
            alt="MOMAS D.O.O. workspace"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}
